import React, { useState,useContext } from 'react'
import { ActiveInsuranceModel } from '../../../../models/insurance-models/ActiveInsuranceModel'
import { Button, Dialog, Grid, makeStyles, MenuItem, Popover, Select, TextField, Checkbox, FormControlLabel } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import {ModificationContextStore} from '../../../../context/ModificationContext'
import { Controller, useForm } from 'react-hook-form';
import { HullItemSelectView } from '../../../Hull/HullItemSelectView';
import { HULL_MAX_LENGTH_SERIAL_NUMBER, HULL_MIN_LENGTH_SERIAL_NUMBER } from '../../../../Constants';
import { FirebaseConfigKey, FirebaseService } from '../../../../services/FirebaseService';
import { SessionService } from '../../../../services/SessionService';
import { InsuranceBillingPeriod } from '../../../../models/insurance-models/InsuranceBillingPeriodModel';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import { SessionContextStore } from '../../../../context/SessionContext';
import { HullAddDisclaimer } from '../../../Hull/HullAddDisclaimer';


interface PolicyAdditionalInsuredSectionProps {
    insurance: ActiveInsuranceModel
}


export const CustomizeEquipmentModify = ({defaultValues, mode, showFields,modificationObject,isRenewal}) => {
    const { register, triggerValidation, watch, setValue, errors, control, getValues, reset } = useForm({ mode: 'onChange', defaultValues})
    const modificationContext = React.useContext(ModificationContextStore)
    const sessionContext = React.useContext(SessionContextStore)
    const [isRented, setIsRented] = React.useState(false)
    const [spearPartDisabled, setSpearPartDisabled] = useState(false);
    const maximumEquipmentValue = SessionService.isAdmin() ? FirebaseService.getNumber(FirebaseConfigKey.MAXIMUM_EQUIPMENT_VALUE_FOR_ADMIN) : (SessionService.isBroker()? FirebaseService.getNumber(FirebaseConfigKey.MAXIMUM_EQUIPMENT_VALUE_FOR_BROKER) : FirebaseService.getNumber(FirebaseConfigKey.MAXIMUM_EQUIPMENT_VALUE))
    const dateRange ={
        startDate: new Date(),
        endDate: defaultValues.end_date,
        key: 'selection'
    };
    const [isChecked, setIsChecked] = useState(false);
    


    React.useEffect(() => {

        if (mode.add){
            reset({description:'', serial:'', value:'', quantity: 1, is_rented:false, type: '', id: '',  start_date: dateRange.startDate, end_date: new Date().setDate(new Date().getDate() + 30)})
        }

        if (mode.modify){
            const rpac = sessionContext.user.commercial
            reset({description: defaultValues.description, serial: defaultValues.serial, value: defaultValues.value, quantity: defaultValues.quantity, is_rented:defaultValues.is_rented, type: defaultValues.type, id: defaultValues.id, startDate: !!defaultValues.start_date? defaultValues.start_date: dateRange.startDate ,endDate: !!defaultValues.end_date? defaultValues.end_date: null, rpac })
            if(!!defaultValues.end_date){
                setIsChecked(true)
            }
        }
    }, [mode])

    React.useEffect(() => {
        register({ name: 'type'})
        register({ name: 'id'})
    }, [])

    React.useEffect(() => {
            const equipmentsType = modificationObject.equipment.map(equ => equ.type)
            const isSparePartInTheList = equipmentsType.includes('Spare part')
            setSpearPartDisabled(isSparePartInTheList)
    },[modificationObject.equipment])



    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
      };

    const onSubmit = async () => {
        let valid = await triggerValidation()
        if(valid) {
            const hull = getValues();
            const data = {... hull}
            const startDate = hull.start_date ? new Date(hull.start_date).toUTCString() : new Date().toUTCString()
            const endDate = hull.end_date ? new Date(hull.end_date).toUTCString() : null
            data.start_date = startDate 
            data.end_date = endDate
            data.deductibleRate = parseInt(defaultValues.deductibleRate)
            if(data.rpac){
                if(data.isRenewal) {
                    modificationContext.setCommercialSubscription(true)
                } else {
                    modificationContext.setCommercialInsurance(true)
                }
            }
            if (mode.modify){
                modificationContext.editEquipment(data, mode.index, isRenewal)
            }

            if (mode.add){
                 modificationContext.addEquipment(data, mode.index, isRenewal)
            }
            showFields()
        }
    }


    return (
    <React.Fragment>
         <Grid container xs={12} md={12} spacing={2}>

        <Grid item xs={12} md={3}>
        <Controller control={control} 
                rules={{validate: x => x && x != 'type' && x != 'equipment'}} 
                helperText={!!errors.type && 'Required'}
                error={!!errors.type}
                name="type" 
                as= {<TextField select size="small" fullWidth variant="outlined" label="Type" defaultValue={defaultValues.type} name='type' InputLabelProps={{style: {color: 'lightgrayblue'}}} className={'lightgrayblue'} >
                {modificationContext.equipmentTypes.map(
                                (type, index) => {
                            return (
                                <MenuItem disabled={type.name === "Spare part" && spearPartDisabled} key={index} value={type.name}> <HullItemSelectView type={type} size={'tiny'}/> </MenuItem>
                               )})}
                    </TextField>} />
        </Grid>
        <Grid item xs={12} md={3}>
        <TextField size="small" fullWidth variant="outlined" label="Serial number" type="text" name="serial" inputRef={register({maxLength: HULL_MAX_LENGTH_SERIAL_NUMBER})} helperText={errors.serial && `Serial must be between ${HULL_MIN_LENGTH_SERIAL_NUMBER} - ${HULL_MAX_LENGTH_SERIAL_NUMBER} characters`} error={!!errors.serial} />
        </Grid>
        <Grid item xs={6} md={6}>
        <TextField size="small" fullWidth variant="outlined" className={`modify-hull lightgrayblue ${isMobile ? `text-tiny` : `text-small`}`} label="Make" type="text" name="description" inputRef={register({required: true})} helperText={isMobile ? '' : `Describe your item, for example, Zenmuse X5S Camera`} error={!!errors.description} />

        </Grid>
        <Grid item xs={6} md={3}>
            <TextField size="small" fullWidth variant="outlined" label={`Value ${isMobile ? `` : `($0-$${maximumEquipmentValue.toLocaleString()})`}`} type="number" name="value" inputRef={register({required: true, min: FirebaseService.getNumber(FirebaseConfigKey.MINIMUN_EQUIPMENT_VALUE), max: maximumEquipmentValue})} helperText={errors.value && `Value must be between ${FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}${FirebaseService.getNumber(FirebaseConfigKey.MINIMUN_EQUIPMENT_VALUE)} - ${FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}${maximumEquipmentValue.toLocaleString()}`} error={!!errors.value}/>
        </Grid>
        <Grid item xs={6} md={3}>
            <TextField disabled={true} size="small" fullWidth variant="outlined" label={`Quantity`} type="number" name="quantity" inputRef={register({required: true, validate: x => x > 0})}  helperText={!!errors.quantity && 'Required'} error={!!errors.quantity}/>
        </Grid>
        <Grid item xs={12} md={3}>
        <Button className={`${isMobile ? `margin-top-small` : ``} fullwidth add-hull bold textcenter`} onClick={onSubmit} color="primary">
                {`${mode.modify ? `Update` : `Add Equipment`}`}
        </Button>
        </Grid>
        <HullAddDisclaimer className={"margin-top-basic"}/>
        </Grid>
                
    </React.Fragment>)
}